import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, IconButton, Typography } from "@mui/material";
import { DeleteIcon, EXLIcon } from "../assets/svg";
export var FileAttachmentComponent = function (props) {
    var _fileAttachment$FileN, _fileAttachment$Size;
    var value = props.value, _a = props.name, name = _a === void 0 ? "AttachmentUploader" : _a, error = props.error, onChange = props.onChange;
    var fileList = Array.isArray(value === null || value === void 0 ? void 0 : value[name]) ? value[name] : [];
    var fileAttachment = fileList.length > 0 ? fileList[fileList.length - 1] : null;
    var fileName = (_fileAttachment$FileN = fileAttachment === null || fileAttachment === void 0 ? void 0 : fileAttachment.FileName) !== null && _fileAttachment$FileN !== void 0 ? _fileAttachment$FileN : fileAttachment === null || fileAttachment === void 0 ? void 0 : fileAttachment.name;
    var fileSizeMB = ((_fileAttachment$Size = fileAttachment === null || fileAttachment === void 0 ? void 0 : fileAttachment.Size) !== null && _fileAttachment$Size !== void 0 ? _fileAttachment$Size : fileAttachment === null || fileAttachment === void 0 ? void 0 : fileAttachment.size) / (1024 * 1024);
    var handleClick = function () {
        if (onChange) {
            onChange(null, [_objectSpread(_objectSpread({}, fileAttachment), {}, {
                    IsDeleted: 1
                })]);
        }
    };
    if (!fileAttachment || (fileAttachment === null || fileAttachment === void 0 ? void 0 : fileAttachment.IsDeleted) === 1) {
        return null;
    }
    if (fileAttachment || (fileAttachment === null || fileAttachment === void 0 ? void 0 : fileAttachment.IsDeleted) !== 1) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%"
            }
        }, /*#__PURE__*/ React.createElement(EXLIcon, null), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                flex: 1,
                ml: 1
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1"
        }, fileName), fileAttachment !== null && fileAttachment !== void 0 && fileAttachment.size || fileAttachment !== null && fileAttachment !== void 0 && fileAttachment.Size ? /*#__PURE__*/ React.createElement(Typography, {
            variant: "caption",
            color: "text.secondary"
        }, Math.round(((fileAttachment === null || fileAttachment === void 0 ? void 0 : fileAttachment.size) || (fileAttachment === null || fileAttachment === void 0 ? void 0 : fileAttachment.Size)) / 1000), " ", "KB") : null), /*#__PURE__*/ React.createElement(IconButton, null, /*#__PURE__*/ React.createElement(DeleteIcon, {
            onClick: handleClick,
            sx: {
                fontSize: 36
            }
        }))), /*#__PURE__*/ React.createElement(Typography, {
            color: "error.main"
        }, error === null || error === void 0 ? void 0 : error[name]));
    }
};
